<template>
  <div>
    <vue-easy-lightbox
      :visible="lightboxImageIndex !== null"
      :imgs="inventoryImages"
      :index="lightboxImageIndex"
      @hide="lightboxImageIndex = null"
    ></vue-easy-lightbox>

    <Header :code="code" :team_id="team_id" points="-" />

    <div class="game-texture-layer"></div>

    <div class="cont-fullwidth black-bg white-text">
      <div class="row d-flex align-items-center vh-20">
        <div class="col-12 text-center pad-left-30 pad-right-30">
          <h3
            class="termina-black"
            style="text-transform: uppercase; float: left;"
          >
            Inventory
          </h3>
          <router-link
            :to="{
              name: 'challenge-play',
              params: {
                code: code,
                team_id: team_id,
                challengeIndex: gameData.currentChallengeIndex
              }
            }"
          >
            <h3
              class="termina-black"
              style="text-transform: uppercase; float: right;"
            >
              CLOSE
            </h3>
          </router-link>
        </div>
      </div>
    </div>

    <!-- rewards  -->
    <div
      v-if="!loading"
      class="cont-fullwidth black-bg white-text"
      style="height: 100vh !important;"
    >
      <div class="row d-flex  pad-left-30 pad-right-30">
        <div
          v-for="(inventoryItem, index) in inventory"
          :key="index"
          class="col-4 reward text-center"
          @click="lightboxImageIndex = index"
          style="cursor: zoom-in;"
        >
          <div
            class="reward-item text-center termina-reg d-flex align-items-center justify-content-center"
          >
            <img
              class="img-fluid"
              :src="resolveGameAssetURL(gameID, inventoryItem.image)"
              alt="reward"
            />
          </div>
          <p class="termina-reg ">{{ inventoryItem.title }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueEasyLightbox from 'vue-easy-lightbox'
import { gameAssetsMixin } from '../mixins/gameAssetsMixin'
import { mapState, mapActions } from 'vuex'
import Header from '@/components/Header.vue'

export default {
  mixins: [gameAssetsMixin],
  components: {
    Header,
    VueEasyLightbox
  },
  props: {
    code: { type: String, required: true },
    team_id: { type: String, required: true }
  },
  created() {
    if (this.gameData === undefined || this.game.teamData?.id != this.team_id) {
      this.fetchTeamData({ code: this.code, teamId: this.team_id })
    }
  },
  data() {
    return {
      lightboxImageIndex: null
    }
  },
  computed: {
    ...mapState({
      game: state => state.game
    }),
    inventory() {
      return this.game.teamData?.inventory
    },
    inventoryImages() {
      return this.game.teamData?.inventory?.map(inventoryItem => {
        return this.resolveGameAssetURL(this.gameID, inventoryItem.image)
      })
    },
    gameData() {
      return this.game.teamData?.gameData
    },
    gameID() {
      return this.game.teamData?.game
    },
    loading() {
      return this.gameData === undefined
    }
  },
  methods: {
    ...mapActions('game', ['fetchTeamData'])
  }
}
</script>
<style scoped>
.reward-item:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8) !important;
  -webkit-transition: none;
  -moz-transition: none;
  transition: none;
}

.reward-item:hover:after {
  width: 200%;
  background-color: rgba(0, 0, 0, 0) !important;
  -webkit-transition: all 1s ease-in-out;
  -moz-transition: all 1s ease-in-out;
  transition: all 1s ease-in-out;
}

.reward-item img {
  height: 80% !important;
  object-fit: contain;
  width: 100% !important;
}

.reward-item {
  height: 18.5vh !important;
}
</style>
